export default "__VITE_ASSET__DFQTKFIU__"